import axiosInstance from 'api/axiosInstance'
import {
    type IArticleResponse,
    type IArticleSearchResponse,
    type ICategoriesResponse,
    type ISectionsWithCategoryIdResponse
} from 'pages/howTo/types/interfaces/IHowTo'

export const getCategories = async () => {
    const { data } = await axiosInstance<ICategoriesResponse>({
        method: 'GET',
        url: `/api/zendesk/help/categories`
    })
    return data?.data
}

export const getSectionsWithCategoryId = async (id: number | undefined) => {
    const { data } = await axiosInstance<ISectionsWithCategoryIdResponse>({
        method: 'GET',
        url: `/api/zendesk/help/sections/${id}?articles=true&refresh=true`
    })
    return data
}

export const getArticle = async (id: string | undefined) => {
    const { data } = await axiosInstance<IArticleResponse>({
        method: 'GET',
        url: `/api/zendesk/help/article/${id}?refresh=true`
    })
    return data
}

export const searchArticle = async ({
    query,
    category
}: {
    query: string
    category: string
}) => {
    const { data } = await axiosInstance<IArticleSearchResponse>({
        method: 'POST',
        url: `/api/zendesk/help/article/search`,
        data: {
            query,
            category
        }
    })

    return data
}
